import { BarContainer, Container, IconBox, ImageContainer, NoStudent, ResualtArea, ResualtItem, SearchArea, SearchBarText, SearchPop } from "./SearchBar.styled";
import Search_Icon from '@assets/svg/subnav_search.svg';
import Users_Icon from '@assets/svg/users-1.svg';
import Cross_Icon from '@assets/svg/match/missing.svg';
import StudentThumbnail from "@components/StudentThumbnail";
import { useI18n } from '@i18n/useI18n';
import { useEffect, useRef, useState } from "react";
import { useDetectClickOutside } from "react-detect-click-outside";
import { useStore } from "@store/appStore";
import RainbowLoader from "@components/Loaders/RainbowLoader";


interface IProps {
    student?: any;
}

const SearchBar = (props: IProps) => {
    const { search, client, searchResults, clearSearch, setAdminSelection, setAdminSelectedStudent, adminSelectedStudent, searchQuery } = useStore();
    const i18n = useI18n();
    const [open, setOpen] = useState(false)
    const searchRef = useRef(null);

    useEffect(() => {
        searchRef.current?.focus();
    }, [searchRef.current])

    let handleSearch = async (e) => {
        let value = e.target.value;

        if (value.length > 1) {
            await search(value, false, client.UserName, null, false, 90)
        }
        else
        {
            clearSearch();
        }

        if(value.length === 2 && open === false){
            setOpen(true)
        }
    }

    let clearSelectedStudent = () => {
        setAdminSelectedStudent(null);
        setAdminSelection(null, null, null, null);
        clearSearch();
        if(searchRef.current !== null){
            searchRef.current.value = "";

        }
    }

    let handleClick = (s) => {
        // console.log("clicked", s);
        setAdminSelection(s.displayname, s.uni_name, s.type, s.id);
        const seperatedName = s.displayname.replace(`${s.uni_name} -`, '');
        setAdminSelectedStudent(seperatedName, '', s.uni_name);
        searchRef.current.value = "";
        clearSearch();
       
    }

    return (
        <BarContainer>
            <Container>
                <IconBox>
                    <Search_Icon />
                </IconBox>
                {props.student !== null?
                    <>
                        <ImageContainer>
                            <StudentThumbnail font="18px" name={props.student.name} src={props.student.username} />
                        </ImageContainer>
                        <SearchBarText>
                            <span>{props.student.name}</span>
                            <span>{props.student.coins} {i18n.t("attender-coins")}</span>
                        </SearchBarText>
                        <Cross_Icon onClick={clearSelectedStudent} />
                    </>
                    :
                    <>
                        <SearchBarText>
                            <input placeholder={i18n.t("write-search")} ref={searchRef} onChange={handleSearch} />
                        </SearchBarText>
                        {searchRef?.current?.value?.length > 0 && <Cross_Icon onClick={clearSelectedStudent} />}
                    </>
                }
            </Container>
            <SearchPop show={searchRef?.current?.value?.length > 1 && searchRef?.current?.value !== "" }>
                <ResualtArea>
                    {searchResults?.loading?<RainbowLoader />:searchResults?.data?.length > 0 ? searchResults?.data?.filter(s => s.type === "STUDENT").map((student, index) => {
                        let studentName = student.displayname.split('-')[1];
                        return <ResualtItem key={index} onClick={() => handleClick(student)}>
                            <ImageContainer>
                                <StudentThumbnail font="20px" name={studentName} src={student.uni_name} />
                            </ImageContainer>
                            <span>{studentName}</span>
                        </ResualtItem>
                    }) :<NoStudent>
                        <Users_Icon />
                        <span>{i18n.t("no-resualt-title")}</span>
                        <span>{i18n.t("no-resualt-text")}</span>
                    </NoStudent>}
                </ResualtArea>
            </SearchPop>
        </BarContainer>
    )
}

export default SearchBar;